import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./pages/Navbar";
import MobileBottomNav from "./pages/components/MobileBottomNav";
import Footer from "./pages/Footer";
import ErrorBoundary from "./pages/components/ErrorBoundary";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import TutorProfileSetup from "./pages/TutorProfileSetup";
import Search from "./pages/Search";
import TutorProfilePublic from "./pages/TutorProfilePublic";
import BookingSuccess from "./pages/BookingSuccess";
import Bookings from "./pages/Bookings";
import ProtectedRoute from "./pages/ProtectedRoute";
import DashboardRouter from "./pages/DashboardRouter";
import Chat from "./pages/Chat";
import Pay from "./pages/Pay";
import Messages from "./pages/Messages";
import ToastHost from "./pages/components/ToastHost";
import RequestDetails from "./pages/RequestDetails";
import MyRequests from "./pages/MyRequest";
import Transactions from "./pages/Transactions";
import AdminRouter from "./pages/admin/AdminRouter";
import AdminRoute from "./pages/AdminRoute";
import TutorRoute from "./pages/TutorRoute";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import CookieConsent from "./pages/components/CookieConsent";
import FAQ from "./pages/FAQ";
import ForgotPassword from "./pages/ForgotPassword";
import AccountSettings from "./pages/AccountSettings";
import ScrollToTop from "./pages/components/ScrollToTop";
import PageTitle from "./pages/components/PageTitle";
import AuthAction from "./pages/AuthAction";



function PrivacyPage() {
  const { i18n } = useTranslation();
  const isUk = (i18n.resolvedLanguage || i18n.language || "uk").startsWith("uk");

  const sections = isUk ? [
    {
      title: "1. Загальні положення",
      body: `Ця Політика конфіденційності розроблена відповідно до Закону України «Про захист персональних даних» №2297-VI від 01.06.2010 та регулює порядок збору, зберігання, використання і захисту персональних даних користувачів платформи Profio.\n\nВолодільцем та розпорядником персональних даних є:\nProfio (profioplatform.com)\nE-mail: support@profioplatform.com`,
    },
    {
      title: "2. Які дані ми збираємо",
      body: `Ми збираємо такі категорії персональних даних:\n— Ідентифікаційні дані: ім'я, прізвище, адреса електронної пошти;\n— Дані профілю: фото, місто, рід занять, описова інформація;\n— Верифікаційні матеріали (лише для спеціалістів): фото або відео, надіслані через Telegram-бот; ці матеріали передаються через інфраструктуру Telegram і зберігаються Profio;\n— Документи про освіту (лише для спеціалістів, за бажанням): скани диплома про науковий ступінь та/або атестата про вчене звання, назва закладу — для перевірки кваліфікації;\n— Дані транзакцій: історія поповнень, витрат балів, бронювань;\n— Технічні дані: IP-адреса, тип браузера, дата і час звернень;\n— Переписка: повідомлення в чаті платформи.`,
    },
    {
      title: "3. Мета і підстави обробки",
      body: `Ваші персональні дані обробляються з такою метою та на таких підставах:\n— Виконання договору (ст. 11 Закону): реєстрація облікового запису, забезпечення функціонування платформи, обробка платежів через Monobank;\n— Явна згода (ст. 11 Закону): обробка верифікаційних матеріалів (фото/відео) — спеціаліст надає згоду, розпочинаючи процедуру верифікації через Telegram-бот;\n— Явна згода (ст. 11 Закону): обробка документів про освіту — спеціаліст надає згоду окремою позначкою під час їх завантаження; публічно відображаються лише підтверджені науковий ступінь і вчене звання, без копій документів;\n— Законний інтерес: захист від шахрайства, покращення сервісу;\n— Згода (ст. 11 Закону): надсилання інформаційних повідомлень (за наявності підписки).\n\nМи не продаємо ваші персональні дані третім особам.`,
    },
    {
      title: "4. Передача даних третім особам",
      body: `Ваші дані можуть передаватись таким сервісам виключно для забезпечення роботи платформи:\n— Google Firebase — автентифікація та інфраструктура (США; стандартні договірні положення ЄС/SCCs);\n— Monobank / LiqPay — обробка платежів (Україна);\n— Поштові провайдери (Brevo / SendGrid тощо) — надсилання транзакційних листів;\n— Telegram Messenger Inc. / TG Global Limited (Дубай, ОАЕ) — верифікація особи спеціалістів через бот; верифікаційні матеріали (фото/відео) передаються через інфраструктуру Telegram та зберігаються Profio; взаємодія з ботом регулюється Умовами використання Telegram (https://telegram.org/tos) та Політикою конфіденційності Telegram (https://telegram.org/privacy).\n\nПередача даних до сервісів, розташованих за межами України, здійснюється на підставі явної згоди суб'єкта даних або стандартних договірних положень відповідно до ст. 29 Закону №2297-VI.`,
    },
    {
      title: "5. Зберігання даних",
      body: `Ваші персональні дані зберігаються протягом строку існування облікового запису та ще 3 роки після його видалення — для виконання вимог законодавства (податковий облік, вирішення спорів).\n\nВерифікаційні матеріали (фото, відео) зберігаються протягом 12 місяців з моменту верифікації або видалення акаунту та видаляються достроково на ваш запит протягом 30 днів.\n\nСкани документів про освіту доступні лише адміністраторам Profio і видаляються одразу після рішення про перевірку (схвалення чи відмови) або після відкликання заявки спеціалістом. Після цього зберігаються лише результат перевірки, підтверджені ступінь і звання та службовий запис про те, хто і коли ухвалив рішення.`,
    },
    {
      title: "6. Ваші права",
      body: `Відповідно до ст. 8 Закону №2297-VI ви маєте право:\n— Знати, які ваші дані ми обробляємо;\n— Отримати доступ до своїх даних;\n— Вимагати виправлення неточних даних;\n— Вимагати видалення даних (право на забуття);\n— Заперечувати проти обробки;\n— Отримати дані у портативному форматі.\n\nДля реалізації прав надішліть запит на support@profioplatform.com. Відповідь надається протягом 30 днів.`,
    },
    {
      title: "7. Файли cookie",
      body: `Платформа використовує технічно необхідні файли cookie для автентифікації та збереження мовних налаштувань. Аналітичні cookie не використовуються. Використовуючи платформу, ви погоджуєтесь з використанням технічних cookie.`,
    },
    {
      title: "8. Безпека",
      body: `Ми вживаємо технічних і організаційних заходів для захисту ваших даних від несанкціонованого доступу, зміни або знищення. З'єднання з платформою захищено протоколом HTTPS. Доступ до персональних даних мають лише уповноважені особи.`,
    },
    {
      title: "9. Зміни до Політики",
      body: `Ми можемо оновлювати цю Політику. Про суттєві зміни ви будете повідомлені електронною поштою або через повідомлення на платформі не пізніше ніж за 7 днів до набрання змін чинності. Продовження використання платформи після змін означає прийняття нової редакції.`,
    },
    {
      title: "10. Контакти",
      body: `З питань захисту персональних даних звертайтеся:\nProfio (profioplatform.com)\nE-mail: support@profioplatform.com\n\nВи також можете звернутись до Уповноваженого Верховної Ради України з прав людини як до наглядового органу у сфері захисту персональних даних.`,
    },
  ] : [
    {
      title: "1. General Provisions",
      body: `This Privacy Policy is prepared in accordance with the Law of Ukraine "On Personal Data Protection" No. 2297-VI of 01.06.2010 and governs the collection, storage, use and protection of personal data of Profio platform users.\n\nThe data controller is:\nProfio (profioplatform.com)\nE-mail: support@profioplatform.com`,
    },
    {
      title: "2. Data We Collect",
      body: `We collect the following categories of personal data:\n— Identity data: first name, last name, email address;\n— Profile data: photo, city, occupation, descriptive information;\n— Verification materials (specialists only): photo or video submitted via the Telegram bot; these materials pass through Telegram's infrastructure and are stored by Profio;\n— Education documents (specialists only, optional): scans of the scientific degree diploma and/or academic title certificate and the issuing institution — for qualification verification;\n— Transaction data: top-up history, point usage, bookings;\n— Technical data: IP address, browser type, date and time of requests;\n— Correspondence: messages in the platform chat.`,
    },
    {
      title: "3. Purpose and Legal Basis",
      body: `Your personal data is processed for the following purposes and on the following legal bases:\n— Contract performance (Art. 11 of the Law): account registration, platform operation, payment processing via Monobank;\n— Explicit consent (Art. 11 of the Law): processing of verification materials (photo/video) — a Specialist provides consent by initiating the verification procedure via the Telegram bot;\n— Explicit consent (Art. 11 of the Law): processing of education documents — a Specialist gives consent via a separate checkbox when uploading them; only the confirmed degree and academic title are shown publicly, never document copies;\n— Legitimate interest: fraud prevention, service improvement;\n— Consent (Art. 11 of the Law): sending informational messages (where subscribed).\n\nWe do not sell your personal data to third parties.`,
    },
    {
      title: "4. Data Sharing",
      body: `Your data may be transferred to the following services solely to operate the platform:\n— Google Firebase — authentication and infrastructure (USA; standard contractual clauses / SCCs);\n— Monobank / LiqPay — payment processing (Ukraine);\n— Email providers (Brevo / SendGrid etc.) — transactional emails;\n— Telegram Messenger Inc. / TG Global Limited (Dubai, UAE) — specialist identity verification via bot; verification materials (photo/video) pass through Telegram's infrastructure and are stored by Profio; the Specialist's interaction with the bot is governed by Telegram's Terms of Service (https://telegram.org/tos) and Privacy Policy (https://telegram.org/privacy).\n\nTransfers of data outside Ukraine are carried out on the basis of the data subject's explicit consent or standard contractual clauses in accordance with Art. 29 of Law No. 2297-VI.`,
    },
    {
      title: "5. Data Retention",
      body: `Your personal data is stored for the duration of your account and for 3 years after deletion — to comply with legal requirements (tax records, dispute resolution).\n\nVerification materials (photos, videos) are stored for 12 months from verification or account deletion and can be deleted earlier upon your request within 30 days.\n\nEducation document scans are accessible only to Profio administrators and are deleted immediately after the review decision (approval or rejection) or when the Specialist withdraws the submission. Afterwards we keep only the outcome, the confirmed degree and title, and an internal record of who made the decision and when.`,
    },
    {
      title: "6. Your Rights",
      body: `Under Art. 8 of Law No. 2297-VI you have the right to:\n— Know what data we process about you;\n— Access your personal data;\n— Request correction of inaccurate data;\n— Request deletion of your data (right to be forgotten);\n— Object to processing;\n— Receive your data in a portable format.\n\nTo exercise your rights, send a request to support@profioplatform.com. We respond within 30 days.`,
    },
    {
      title: "7. Cookies",
      body: `The platform uses technically necessary cookies for authentication and language preference storage. No analytics cookies are used. By using the platform you consent to the use of technical cookies.`,
    },
    {
      title: "8. Security",
      body: `We implement technical and organisational measures to protect your data from unauthorised access, alteration or destruction. Platform connections are secured with HTTPS. Access to personal data is restricted to authorised personnel only.`,
    },
    {
      title: "9. Policy Changes",
      body: `We may update this Policy. You will be notified of material changes by email or an in-platform notice at least 7 days before changes take effect. Continued use of the platform after changes constitutes acceptance of the updated Policy.`,
    },
    {
      title: "10. Contact",
      body: `For privacy-related inquiries:\nProfio (profioplatform.com)\nE-mail: support@profioplatform.com\n\nYou may also contact the Ukrainian Parliament Commissioner for Human Rights as the supervisory authority for personal data protection.`,
    },
  ];

  return (
    <main className="min-h-screen bg-[#272c39] text-white">
      <div className="mx-auto max-w-3xl px-4 md:px-6 py-16">
        <h1 className="font-unbounded text-3xl font-bold">
          {isUk ? "Політика конфіденційності" : "Privacy Policy"}
        </h1>
        <p className="mt-2 text-sm text-white/50">
          {isUk ? "Редакція від травня 2026 р." : "Last updated: May 2026"}
        </p>

        <div className="mt-8 space-y-8 text-white/80 leading-relaxed">
          {sections.map((s) => (
            <section key={s.title}>
              <h2 className="font-semibold text-white text-lg mb-2">{s.title}</h2>
              <p className="whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

function NotFoundPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 md:px-6 py-24 text-center text-white">
      <p className="text-7xl font-extrabold text-[#7269e3] font-unbounded">404</p>
      <h1 className="mt-4 font-unbounded text-2xl font-bold">Page not found</h1>
      <p className="mt-3 text-white/60">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a
        href="/"
        className="mt-8 inline-block rounded-xl bg-[#7269e3] px-6 py-3 text-sm font-semibold text-white hover:opacity-90 transition"
      >
        Go home
      </a>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
    <Router>
      <ScrollToTop />
      <PageTitle />
      <ToastHost />
      <Navbar />

      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/tos" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* Firebase email action links (verify email / reset password) land
            here — set as "action URL" in Firebase Console → Auth → Templates,
            so emails link to profioplatform.com instead of firebaseapp.com. */}
        <Route path="/auth/action" element={<AuthAction />} />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding/tutor"
          element={
            <ProtectedRoute>
              <TutorRoute>
                <TutorProfileSetup />
              </TutorRoute>
            </ProtectedRoute>
          }
        />
        <Route path="/search" element={<Search />} />
        <Route path="/tutor/:id" element={<TutorProfilePublic />} />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          }
        />

        {/* Private */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardRouter />
            </ProtectedRoute>
          }
        />

        <Route
          path="/booking/success"
          element={
            <ProtectedRoute>
              <BookingSuccess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <Bookings />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/*"
          element={
           <ProtectedRoute>
           <AdminRoute>
           <AdminRouter />
           </AdminRoute>
         </ProtectedRoute>
        }
       />

        <Route
          path="/chat/:peerId"
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pay"
          element={
            <ProtectedRoute>
              <TutorRoute>
                <Pay />
              </TutorRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <TutorRoute>
                <Transactions />
              </TutorRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-requests"
          element={
            <ProtectedRoute>
              <MyRequests />
            </ProtectedRoute>
          }
        />

        <Route
          path="/requests/:id"
          element={
            <ProtectedRoute>
              <RequestDetails />
            </ProtectedRoute>
          }
        />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Footer />

      <CookieConsent />

      {/* Bottom padding so the footer clears the fixed mobile nav bar instead of
          being overlapped by it. Must come AFTER Footer (it's the last thing in
          the scrollable flow), and must account for the safe-area inset on
          notched phones, otherwise the nav bar sits on top of/hides the footer. */}
      <div
        className="md:hidden"
        style={{ height: "calc(4.5rem + env(safe-area-inset-bottom, 0px))" }}
        aria-hidden="true"
      />
      <MobileBottomNav />
    </Router>
    </ErrorBoundary>
  );
}
